module.exports = __webpack_public_path__ + "static/who-5926ec01d15cc30df9534c9626094799.svg";